import { Card } from "@/components/ui";
import React from "react";

export function FormCard({ children }: { children: React.ReactNode }) {
  return (
    <Card className="flex flex-col bg-white shadow-sm border-slate-200 rounded-xl overflow-hidden">{children}</Card>
  );
}

FormCard.Header = function FormCardHeader({ title, description }: { title: string; description: string }) {
  return (
    <Card.Header className="pb-4">
      <Card.Title className="text-lg font-semibold tracking-tight text-slate-900">{title}</Card.Title>
      <Card.Description className="text-sm text-slate-500">{description}</Card.Description>
    </Card.Header>
  );
};

FormCard.Content = function FormCardContent({ children }: { children: React.ReactNode }) {
  return <Card.Content className="flex flex-col gap-4 grow">{children}</Card.Content>;
};

FormCard.Actions = function FormCardActions({ children }: { children: React.ReactNode }) {
  return (
    <Card.Footer className="flex justify-end gap-3 mt-auto pt-4 pb-4 border-t border-slate-100 bg-slate-50/50">
      {children}
    </Card.Footer>
  );
};
